<template>
  <el-dialog
    width="450px"
    :visible="modalVisible"
    :before-close="handleCloseModal"
    :close-on-click-modal="false"
  >
    <h2 class="form-section-header">
      Filter settings
    </h2>

    <h3 class="black-text mb-5">Select date range</h3>
    <el-date-picker
      :clearable="false"
      type="datetimerange"
      v-model="dateRange"
      align="right"
      unlink-panels
      range-separator="To"
      start-placeholder="Start date"
      end-placeholder="End date"
      :picker-options="datePickerOptions"
    >
    </el-date-picker>
    <el-form id="faxes-advanced-modal" class="form-modal">
      <!-- Phone Number -->
      <h3 class="black-text mb-5">Search by phone number</h3>
      <div class="el-input el-input--prefix">
        <input
          v-model="number"
          type="text"
          autocomplete="off"
          placeholder="Phone Number"
          class="el-input__inner"
          v-mask="'(###)-###-####'"
        />
        <span class="el-input__prefix">Phone Number</span>
      </div>
      <el-button @click="doAdvanced" class="mt-20">
        Update
      </el-button>
    </el-form>
  </el-dialog>
</template>

<script>
import moment from "moment";
export default {
  name: "FaxesFilterSettings",

  props: {
    modalVisible: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      dateRange: null,
      number: "",
      datePickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment()
                  .subtract(1, "week")
                  .format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment()
                  .subtract(1, "month")
                  .format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment()
                  .subtract(3, "months")
                  .format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            }
          }
        ],
        disabledDate(time) {
          const difference = moment(time).diff(moment(), "days");
          return !(difference > -181 && difference < 1);
        }
      }
    };
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    handleCloseModal() {
      this.$emit("closeModal");
    },

    resetFilters() {
      this.dateRange = null;
      this.number = "";
    },

    updateDateRangePicker() {
      this.dateRange = [moment(this.startDate), moment(this.endDate)];
    },

    doAdvanced() {
      const startDate = moment(this.dateRange[0]).format("YYYY-MM-DD");
      const endDate = moment(this.dateRange[1]).format("YYYY-MM-DD");

      const { timezone } = this.user;

      const serverOffset = moment.tz("America/Chicago").utcOffset();
      const userOffset = moment.tz(timezone).utcOffset();
      const timeOffset = userOffset - serverOffset;
      const offsetMinutes = Math.abs(timeOffset);
      const queryStart =
        timeOffset > 0
          ? moment(startDate)
              .subtract(offsetMinutes, "minutes")
              .format("YYYY-MM-DD HH:mm:ss")
          : moment(startDate)
              .add(offsetMinutes, "minutes")
              .format("YYYY-MM-DD HH:mm:ss");
      const queryEnd =
        timeOffset > 0
          ? moment(endDate)
              .subtract(offsetMinutes, "minutes")
              .format("YYYY-MM-DD HH:mm:ss")
          : moment(endDate)
              .add(offsetMinutes, "minutes")
              .format("YYYY-MM-DD HH:mm:ss");

      const dateFilter = { $gte: queryStart, $lt: queryEnd };
      let numberFilter;
      if (this.number) {
        numberFilter = this.number.replace(/[()-]/g, "").replace(/\s/g, "");
      }

      this.$emit("applyFilter", {
        dateFilter,
        numberFilter
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.el-input {
  &__inner {
    padding-left: 10px;
  }
}
</style>
